import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { CustomProperty, PaidTimeOffPolicy } from "winslow-core";
import { selectUser } from "../../../redux/features/appData";
import { apiGetPaidTimeOffPoliciesForWorkspace } from "../../../services/PaidTimeOffPolicyService";
import { POLICY_EDITOR_TABS } from "../app-time-off/AppTimeOff";
import ModalBasicConfirm from "../../common/ModalBasicConfirm";
import { useNavigate } from "react-router-dom";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyPTOPoliciesProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyPTOPolicies = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyPTOPoliciesProps) => {

    const navigate = useNavigate();
    const storeUser = useSelector(selectUser);
    const [paidTimeOffPolicies, setPaidTimeOffPolicies] = useState<PaidTimeOffPolicy[] | undefined>(undefined);
    const [selected, setSelected] = useState<string[]>([]);

    const [confirmLeavePage, setConfirmLeavePage] = useState<boolean>(false);

    useEffect(() => {
        if (!storeUser?.currentWorkspaceId) {
            return;
        }

        (async () => {
            const paidTimeOffPolicies = await apiGetPaidTimeOffPoliciesForWorkspace(storeUser?.currentWorkspaceId || "");

            if (paidTimeOffPolicies) {
                setPaidTimeOffPolicies(paidTimeOffPolicies);
            }
        })();
    }, [storeUser]);

    useEffect(() => {
        onChange(customProperty.label, selected);
    }, [selected]);

    const handleConfirmLeavePage = () => {
        setConfirmLeavePage(false);
        navigate("/app/time-off/" + POLICY_EDITOR_TABS.POLICIES);
    }

    const requiredError = validate && (selected.length === 0 || paidTimeOffPolicies?.length === 0) && customProperty.required;

    return (
        <>
            <div className="app-custom-property-multiple">
                <div className="app-custom-property-value">
                    {paidTimeOffPolicies && paidTimeOffPolicies.map((policy, index) => (
                        <div key={index} className="app-custom-property-multiple-choice">
                            <input
                                type="checkbox"
                                disabled={disabled}
                                name="system-PTOPolicies"
                                checked={selected.includes(policy.id)}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelected([...selected, policy.id]);
                                    } else {
                                        setSelected(selected.filter(p => p !== policy.id));
                                    }
                                }}
                            />
                            
                            <div style={{width: "100%", flexShrink: 0}}>{policy.name}</div>
                            
                        </div>
                    ))}
                    {!disabled && paidTimeOffPolicies && paidTimeOffPolicies.length === 0 && (
                        <div className="app-custom-property-multiple-choice">
                            <div style={{width: "100%", flexShrink: 0}}>
                                <a 
                                    onClick={disabled ? undefined : (e: any) => {
                                        setConfirmLeavePage(true);
                                        e.preventDefault();
                                    }}
                                    style={{
                                        textDecoration: "underline", 
                                        color: "blue",
                                        cursor: "pointer"
                                    }}
                                >
                                    Create a policy
                                </a>
                            </div>
                        </div>
                    )}

                    <AppCustomPropertyError 
                        flagRequired={requiredError}
                    />

                </div>  
            </div>

            {confirmLeavePage && (
                <ModalBasicConfirm
                    isOpen={confirmLeavePage}
                    onClose={() => setConfirmLeavePage(false)}
                    title="Confirm Leave Page"
                    message="Are you sure you want to leave the page? You will lose any changes you have not saved."
                    onContinue={() => {
                        setConfirmLeavePage(false)
                        handleConfirmLeavePage();
                    }}
                />
            )}
        </>
    )
}
